import axios from "axios";
import { localStorageItem } from './../../utils/LocalStorage';
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts";
import { OctResponse } from '../../models/OctResponse';
import { urlParamsConfig } from "../../utils/ParamsUtils";

const API = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["apiUrl"] || process.env.REACT_APP_WMS_API_URL;
const API_DON_VI = API + "/organizations";

export const addDV = (data: any) => {
  let url = API_DON_VI;
  return axios.post(url, data);
};
export const updateDV = (id: string, data: any) => {
  let url = API_DON_VI + `/${id}`;
  return axios.put(url, data);
};

export const searchDanhSachDV = (searchData: any): Promise<OctResponse<any>>  => {
  const url = `${API_DON_VI}` + `/search`;
  return axios.get(urlParamsConfig(url, searchData))
};

export const deleteDV = (id: string) => {
  const url = `${API_DON_VI}` + `/${id}`;
  return axios.delete(url);
};